import { environment } from './../../environments/environment';
import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../api/services/auth.service';
import 'rxjs/add/operator/do';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // needed because of this https://github.com/angular/angular/pull/19809 has not been merged yet
    const auth = this.injector.get(AuthService);

    if (request.url.includes('oauth/token')) {
      const basicAuth = environment.basicAuthClientID + ':' + environment.basicAuthSecret;
      request = this.setAuthorizationHeader(request, 'Basic ' + btoa(basicAuth));
    } else if (request.url.includes('resetPassword') || request.url.includes('changePassword')
                || request.url.includes('fileById')) {
    } else {
      request = this.setAuthorizationHeader(request, `Bearer ${auth.getAccessToken()}`);
    }
    return next.handle(request);
  }

  private setAuthorizationHeader(request: HttpRequest<any>, authValue: string) {
    return request.clone({
      setHeaders: {
        Authorization: authValue
      }
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/interceptors/token.interceptor.ts